import { render, staticRenderFns } from "./Dates.vue?vue&type=template&id=32aa9f80&scoped=true&"
import script from "./Dates.vue?vue&type=script&lang=ts&"
export * from "./Dates.vue?vue&type=script&lang=ts&"
import style0 from "./Dates.vue?vue&type=style&index=0&id=32aa9f80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aa9f80",
  null
  
)

export default component.exports